import { useGateValue } from '@coursera-web/statsig';

/**
 * Course Home Redesign rollout flag.
 *
 * Gate: https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/gates/course-home-redesign
 */
export const useCourseHomeRedesign = (): boolean => {
  return useGateValue('course-home-redesign');
};
